export enum ImportFileLoadRowStatus {
  SUCCEED = 'SUCCEED',
  FAILED  = 'FAILED',
  SKIPPED = 'SKIPPED'
}
